import type { Announcement } from '@incidents/contracts';
import { useI18n } from '../i18n.tsx';
import { formatLocalFromDB } from '../dates.ts';

const SEVERITY_COLORS: Record<string, string> = {
  info: 'bg-blue-50 border-blue-300 text-blue-800',
  warning: 'bg-yellow-50 border-yellow-300 text-yellow-800',
  critical: 'bg-red-50 border-red-300 text-red-800',
  error: 'bg-red-50 border-red-300 text-red-800',
  maintenance: 'bg-purple-50 border-purple-300 text-purple-800',
  success: 'bg-emerald-50 border-emerald-300 text-emerald-800',
};

const SEVERITY_ICONS: Record<string, string> = {
  maintenance: 'fa-tools',
  critical: 'fa-triangle-exclamation',
  error: 'fa-triangle-exclamation',
  warning: 'fa-exclamation-circle',
  info: 'fa-info-circle',
  success: 'fa-check-circle',
};

export function AnnouncementBanner({ announcements }: { announcements: Announcement[] }) {
  const { lang } = useI18n();
  if (announcements.length === 0) return null;
  return (
    <div className="space-y-2 mb-4">
      {announcements.map((ann) => {
        const color = SEVERITY_COLORS[ann.severity] ?? SEVERITY_COLORS.info!;
        const icon = SEVERITY_ICONS[ann.severity] ?? 'fa-info-circle';
        return (
          <div
            key={ann.id}
            className={`rounded-xl border-2 p-4 shadow-sm ${color}`}
          >
            <div className="flex items-start gap-3">
              <i className={`fas ${icon} text-lg mt-0.5`} />
              <div className="flex-1">
                <div className="font-semibold text-base">{ann.title}</div>
                <div className="text-sm mt-1">{ann.message}</div>
                <div className="text-xs mt-2 opacity-70">
                  {formatLocalFromDB(ann.created_at, lang)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
